<script>
export default {
    methods: {
        onMenuClicked() {
            this.params.showColumnMenu(this.$refs.menuButton);
        },
    },
    render(h) {
        // ag的头部菜单按钮
        const menuButton = h('div', {
            ref: 'menuButton',
            class: 'ag-icon ag-icon-menu ag-header-cell-menu-button', // 直接使用ag的样式
            on: {
                click: this.onMenuClicked,
            },
        });
        return this.params.renderHeader ? h('div', { class: 'custom-header_content' }, [this.params.renderHeader(h), menuButton]) : h('span', this.params.displayName);
    },
};
</script>

<style lang="less" scoped>
.custom-header_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
}
</style>
